import { useState, useCallback } from 'react';
const useInvalidations = ({ inputs = 0 }) => {
    const [invalidations, setInvalidations] = useState(Array(inputs).fill(false));
    const onInvalidate = useCallback((idx) => (v) => setInvalidations((p) => {
        const c = [...p];
        c[idx] = v;
        return c;
    }), []);
    return {
        onInvalidate,
        invalidations,
        setInvalidations,
    };
};
export default useInvalidations;
